'use client';

import dynamic from 'next/dynamic';
import { useState } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import LoggedInUserCta from './LoggedInUserCta';
import LoggedOutUserCta from './LoggedOutUserCta';
import styles from './styles/styles.module.scss';
import { HeaderBackground } from './types';

const SignUpModal = dynamic(() => import('@alltrails/user-auth/components/SignUpModal'), { ssr: false });

type UserCTAProps = {
  background: HeaderBackground;
};

const UserCTA = ({ background }: UserCTAProps) => {
  const user = useUser();
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);

  return (
    <div className={styles.userCta}>
      {user ? (
        <LoggedInUserCta background={background} user={user} />
      ) : (
        <LoggedOutUserCta background={background} onLogIn={() => setIsSignUpModalOpen(true)} />
      )}
      {/* SignUpModal is a stable sibling so it survives the logged-out -> logged-in transition and its post-auth upsell step isn't torn down. */}
      {isSignUpModalOpen && (
        <SignUpModal
          autoClose
          closeModal={() => setIsSignUpModalOpen(false)}
          isOpen={isSignUpModalOpen}
          onSuccess={() => {
            setIsSignUpModalOpen(false);
            window.location.reload();
          }}
          trigger="Global Nav Menu"
          upsellTrigger="Global Nav Menu"
        />
      )}
    </div>
  );
};

export default UserCTA;
